
import {default as Group, Controller as GroupController} from './../../../../../zviz2/zviz/components/group';
import Rectangle from './../../../../../zviz2/zviz/components/rectangle';
import Arc from './../../../../../zviz2/zviz/components/arc';
import {extend, cloneObject} from './../../../../../zviz2/zviz/functions';



class Controller extends GroupController{


}


let Blueprint = {
    type: Controller,
    properties: {
        transform: {
            position: {x: 0, y: 0}
        }
    },
    children: [
        
        // zoom in
        extend({
            properties: {
                style: {
                    cursor: 'pointer'
                },
                data: {
                    isHover: false
                }
            },
            children: [
                (parent) => (extend({
                    properties: {
                        style: {
                            fill: 'white',
                            strokeWidth: '2px',
                            stroke: parent.isHover? 'black': '#777'
                        },
                        attributes: {
                            r: 15,
                        }
                    }
                }, Arc) ),

                // plus
                extend({
                    properties: {
                        style: {
                            fill: parent.isHover? 'black': '#777',
                            stroke: 'none'
                        },
                        attributes: {
                            width: 2,
                            height: 10
                        },
                        transform: {
                            position: {x: -1, y: -5}
                        }
                    }
                }, Rectangle),
                extend({
                    properties: {
                        style: {
                            fill: parent.isHover? 'black': '#777',
                            stroke: 'none'
                        },
                        attributes: {
                            width: 10,
                            height: 2
                        },
                        transform: {
                            position: {x: -5, y: -1}
                        }
                    }
                }, Rectangle),
                
            ],
            events: {
                mouseover: (event, ctrl) => { ctrl.isHover = true; ctrl.update() },
                click: (event, ctrl) => { ctrl.parent.trigger('zoomIn'); },
                mouseout: (event, ctrl) => { ctrl.isHover = false; ctrl.update() }
            }
        }, Group),

        // // reset
        // extend({
        //     properties: {
        //         style: {
        //             cursor: 'pointer'
        //         },
        //         transform: {
        //             position: {x:0 , y: 20}
        //         },
        //         data: {
        //             isHover: false
        //         }
        //     },
        //     children: [
        //         (parent) => (extend({
        //             properties: {
        //                 style: {
        //                     fill: parent.isHover? '#fdfdfd': '#f5f5f5',
        //                     strokeWidth: '1px',
        //                     stroke: '#aaa'
        //                 },
        //                 attributes: {
        //                     width: 20,
        //                     height: 20
        //                 }
        //             }
        //         }, Rectangle) ),
                
        //         extend({
        //             properties: {
        //                 style: {
        //                     fill: '#555',
        //                     stroke: 'none'
        //                 },
        //                 transform: {
        //                     position: {x: 10, y: 10}
        //                 },
        //                 attributes: {
        //                     r: 2,
        //                 },
        //             }
        //         }, Arc)
        //     ],
        //     events: {
        //         mouseover: (event, ctrl) => { ctrl.isHover = true; ctrl.update() },
        //         click: (event, ctrl) => { ctrl.parent.trigger('reset'); },
        //         mouseout: (event, ctrl) => { ctrl.isHover = false; ctrl.update() }
        //     }
        // }, Group),

        // zoom out
        extend({
            properties: {
                style: {
                    cursor: 'pointer'
                },
                transform: {
                    position: {x: 0, y: 35}
                },
                data: {
                    isHover: false
                }
            },
            children: [
                (parent) => ( extend({
                    properties: {
                        style: {
                            fill: 'white',
                            strokeWidth: '2px',
                            stroke: parent.isHover? '#000': '#777'
                        },
                        attributes: {
                            r: 15
                        }
                    }
                }, Arc) ),

                // minus
                extend({
                    properties: {
                        style: {
                            fill: parent.isHover? '#000': '#777',
                            stroke: 'none'
                        },
                        attributes: {
                            width: 8,
                            height: 2
                        },
                        transform: {
                            position: {x: -4, y: -1}
                        }
                    }
                }, Rectangle),
                
            ],
            events: {
                mouseover: (event, ctrl) => { ctrl.isHover = true; ctrl.update() },
                click: (event, ctrl) => { ctrl.parent.trigger('zoomOut'); },
                mouseout: (event, ctrl) => { ctrl.isHover = false; ctrl.update() }
            }
        }, Group),

    ]
};

export default Blueprint;
export {Controller, Blueprint};